module.exports = __webpack_public_path__ + "media/images/about-image-ca7c05ac66e08cf2eb6ca861d5414dfd.png";